query sportCompetitionConfigurations(
  $sportId: UUID!
  $search: String = ""
  $order: CompetitionsOrderBy = COMPETITION_NAME_ASC
  $first: Int = 50
  $offset: Int = 0
) {
  competitions: allCompetitions(
    condition: { sportId: $sportId }
    filter: { 
      competitionName: { includesInsensitive: $search },
      limbo: { equalTo: false }
    }
    orderBy: [$order]
    first: $first
    offset: $offset
  ) {
    totalCount
    nodes {
      competitionId
      competitionName
      ageCategory
      gender
      defaultRules
      limbo
      competitionFavoritesByCompetitionId {
            nodes {
            competition {
                competitionName
                competitionId
                }
            }
        }
      region {
        regionId
        regionName
      }
      feedConfiguration: competitionFeedConfigurationsByCompetitionId(
        orderBy: PRIORITY_ASC
      ) {
        nodes {
          feed
          priority
          marketCategories
          coverageExpected
          liveResulting
          resultingMarketCategories
        }
      }
    }
  }
}
